import { APIURL, CONSTS } from '../../constants'
import services from '../services'
import dayjs from 'dayjs'

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult
  if (removedIndex === null && addedIndex === null) return arr

  const result = [...arr]
  let itemToAdd = payload

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0]
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd)
  }

  return result
}

export const generateItems = (count, creator) => {
  const result = []
  for (let i = 0; i < count; i++) {
    result.push(creator(i))
  }
  return result
}

export const launchSso = (store, product, auth_type, event) => {
  switch (auth_type) {
    case CONSTS.SSO_TYPE_BENEFITHUB:
      launchBenefitHub(store, product, event)
      break
    default:
      break
  }
  if (event) {
    event.preventDefault()
  }
}

const openInNewTab = (href) => {
  Object.assign(document.createElement('a'), {
    target: '_blank',
    href
  }).click()
}

const launchBenefitHub = async (store, product, e) => {
  await store.enrollExternal(
    product.id,
    product.partner.id,
    product.product_name
  )
  return store.getBenefitHubData(product)
}

const launchOrion = (store, product, e) => {
  const { load_widget_type } = store.prod_sub.orion
  if (load_widget_type === 'orion_sso_connected') {
    store.openOrionSSO(e)
  } else {
    store.connectOrionSSO(e)
  }
}

const launchQuickBook = (store, product, e) => {
  store.launchQuickBook(e)
}

const initiateRedTailSSO = (store, product, e) => {
  store.connectRedtailSSO('calendar', 0, e)
}

const launchProsites = (store, product, e) => {
  store.launchProsites(e)
}

const initiateAuth = (store, product) => {
  const userData = {
    unique_code: store.sessionData.unique_code,
    client_id: CONSTS.SMARTX_CLIENT_ID,
    domain: CONSTS.SMARTX_DOMAIN
  }
  store.setActionLoader(true)
  services.post(APIURL.API_AUTHENTICATE_OAUTH, userData).then((res) => {
    if (
      res.status === CONSTS.FAILURE &&
      parseInt(res.statusCode) >= CONSTS.HTTP_ERROR_500
    ) {
      store.setActionLoader()
      store.setPageContentLoader()
      store.isAppError = true
    } else if (parseInt(res.statusCode) === CONSTS.ERROR_FEBRIDDEN) {
      store.signSessionExpiredOut()
    } else if (res.status === 'success') {
      const eventForm = document.createElement('form')
      eventForm.className = 'hide'
      eventForm.target = '_blank'
      eventForm.method = 'GET'
      const element1 = document.createElement('input')
      element1.name = 'access_token'
      element1.value = res.response.access_token
      eventForm.appendChild(element1)
      eventForm.action = product.sso_url
      document.body.appendChild(eventForm)
      eventForm.submit()
      store.setActionLoader()
    } else {
      store.setActionLoader()
    }
  })
}

const initiateVentureAuth = (store, product) => {
  const userData = {
    unique_code: store.sessionData.unique_code,
    client_id: CONSTS.VENTURE_CLIENT_ID,
    domain: CONSTS.VENTURE_DOMAIN_AUTH
  }
  store.setActionLoader(true)
  services.post(APIURL.API_AUTHENTICATE_OAUTH, userData).then((res) => {
    if (
      res.status === CONSTS.FAILURE &&
      parseInt(res.statusCode) >= CONSTS.HTTP_ERROR_500
    ) {
      store.setActionLoader()
      store.setPageContentLoader()
      store.isAppError = true
    } else if (parseInt(res.statusCode) === CONSTS.ERROR_FEBRIDDEN) {
      store.signSessionExpiredOut()
    } else if (res.status === 'success') {
      const eventForm = document.createElement('form')
      eventForm.className = 'hide'
      eventForm.target = '_blank'
      eventForm.method = 'GET'
      const element1 = document.createElement('input')
      element1.name = 'code'
      element1.value = res.response.access_token
      eventForm.appendChild(element1)
      eventForm.action = product.sso_url
      document.body.appendChild(eventForm)
      eventForm.submit()
      store.setActionLoader()
    } else {
      store.setActionLoader()
    }
  })
}

const customAuthneticate = (store, product) => {
  const userData = {
    unique_code: store.sessionData.unique_code,
    client_id: CONSTS.VEESTWELL_CLIENT_ID,
    domain: CONSTS.VESTWELL_DOMAIN
  }
  store.setActionLoader(true)
  services.post(APIURL.API_AUTHENTICATE_OAUTH, userData).then((res) => {
    if (
      res.status === CONSTS.FAILURE &&
      parseInt(res.statusCode) >= CONSTS.HTTP_ERROR_500
    ) {
      store.setActionLoader()
      store.setPageContentLoader()
      store.isAppError = true
    } else if (parseInt(res.statusCode) === CONSTS.ERROR_FEBRIDDEN) {
      store.signSessionExpiredOut()
    } else if (res.status === 'success') {
      const eventForm = document.createElement('form')
      eventForm.className = 'hide'
      eventForm.target = '_blank'
      eventForm.method = 'GET'
      const element1 = document.createElement('input')
      element1.name = 'access_token'
      element1.value = res.response.access_token
      eventForm.appendChild(element1)
      eventForm.action = product.sso_url
      document.body.appendChild(eventForm)
      eventForm.submit()
      store.setActionLoader()
    } else {
      store.setActionLoader()
    }
  })
}

const initiateWealthForgeAuth = (store, product) => {
  const { sessionData } = store
  const action_url = product.sso_url + '&user_id=' + sessionData.access_token
  openInNewTab(action_url)
}

const sslUrlAuthentication = (store, product) => {
  if (product.sso_url !== '') {
    openInNewTab(product.sso_url)
  }
}

export const formatCurrency = (value) => {
  return value.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maxFractionDigits: 0
  })
}

export const formatStripeAmount = (value) => {
  return formatCurrency(value / 100)
}

export const formatDate = (date) => {
  return dayjs(date).format('MM-DD-YYYY')
}
